import { render, staticRenderFns } from "./trsContact.vue?vue&type=template&id=90b6023c&scoped=true"
import script from "./trsContact.vue?vue&type=script&lang=js"
export * from "./trsContact.vue?vue&type=script&lang=js"
import style0 from "./trsContact.vue?vue&type=style&index=0&id=90b6023c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b6023c",
  null
  
)

export default component.exports